import React, { useEffect, useState } from 'react';

/*принудительная перерисовка страницы [forced page rerendering]*/

export const Dummy = ({ random = 0 }) => {

  // const [ trigger, setTrigger ] = useState( random );
  // useEffect(() => { setTrigger( random ); }, [ random ])
  
  return (

    <span style = {{ display: 'none' }}>

      {/* { trigger } */}
      { random }

    </span>

  )

}

const useReloadDummy = ( setGlobalDummy = () => {} ) => {

  const [ dummy, setDummy ] = useState( RandomHash() );

  const Anchor = () => (

    <span style = {{ display: 'none' }}>{ dummy }</span>
  
  )

  const Reload = () => { 

    const r = RandomHash();

    setDummy( r );
    setGlobalDummy( r );

  };

  return [ Anchor, Reload ];

}

export const RandomHash = () => {

  let hash = ( Math.random( 10,99 ).toFixed( 3 ) * 1000 ).toString();
  hash += Date.now().toString().substring(0,7);
  hash += ( Math.random( 10,99 ).toFixed( 3 ) * 1000 ).toString();

  return hash;

}

export default useReloadDummy;